<template>
  <div class="wrapper">
    <div class="twoSideBox">
      <div class="leftBox" ref="treeBox" style="width: 200px">
        <h3 class="centerFont">试题分组</h3>

        <mytree
          :treeData="questionType"
          @eventUp="treeEvent"
          @dataUpdate="questionTypeUpdate"
          :searchInput="true"
        ></mytree>
      </div>
      <div class="slider" @mousedown="sliderClick"></div>
      <div class="rightBox">
        <div class="actBar">
          <Button type="primary" icon="md-add" @click="goTo('questionEdit')"
            >新增试题</Button
          >
          <Button type="primary" ghost @click="goTo('questionRepeat')"
            >题库查重</Button
          >
          <Button
            type="primary"
            icon="ios-cloud-upload-outline"
            ghost
            @click="goTo('batchImportQuestion')"
            >导入试题</Button
          >
          <Button type="primary" ghost :disabled="!questionChoosen.length > 0"
            >导出所选试题</Button
          >
          <Button
            type="primary"
            ghost
            :disabled="!questionChoosen.length > 0"
            @click="showTreeChoose"
            >移动到分类</Button
          >
          <Button
            type="error"
            icon="ios-trash-outline"
            ghost
            :disabled="!questionChoosen.length > 0"
            @click="showConfirmModal('delete')"
            >删除试题</Button
          >
        </div>
        <div class="searchBar">
          <div class="pageContainer">
            <el-pagination
              layout="prev, pager, next,total"
              :current-page.sync="searchCondition.jumpPage"
              :page-size.sync="searchCondition.pageSize"
              :total="searchCondition.total"
              @current-change="getQuestionList"
            >
            </el-pagination>
          </div>
          <div class="btnContainer">
            <el-select
              v-model="searchCondition.typeId"
              placeholder="请选择"
              style="width: 120px"
              size="small"
              @change="
                searchConditionInit();
                getQuestionList();
              "
            >
              <el-option
                v-for="item in questionTypeList"
                :key="item.typeName"
                :label="item.typeName"
                :value="item.id"
              >
              </el-option>
            </el-select>
            <el-input
              placeholder="请输入内容"
              v-model="searchCondition.name"
              style="width: 240px; margin-left: 20px"
              size="small"
            >
              <el-button
                slot="append"
                icon="el-icon-search"
                @click="getQuestionList"
              ></el-button>
            </el-input>
          </div>
        </div>
        <div class="tableContainer">
          <Table
            :columns="columns1"
            :data="data1"
            :height="tableHeight"
            @on-selection-change="choosenChange"
            border
          >
            <template slot-scope="{ row, index }" slot="action">
              <el-button
                type="text"
                size="small"
                @click="goToDetail('/questionEdit', row)"
                >详情</el-button
              >
            </template>
          </Table>
        </div>
      </div>
    </div>

    <Modal v-model="treeModal" title="请选择试题分类" @on-ok="treeModalconfirm">
      <mytree
        :treeData="questionTypeForModal"
        @eventUp="moveQuestionGroupEvent"
        @dataUpdate="questionTypeUpdate"
      ></mytree>
    </Modal>
  </div>
</template>

<script>
import mytree from "@/component/tree/mytree.vue";
import {
  getQuestionType,
  appendQuestionType,
  moveQuestionType,
  deleteQuestionType,
  renameQuestionType,
  questionSearch,
  moveQuestionGroup,
  deleteQuestionList,
  getQuestionTypeList,
} from "@/api/question.js";
let that = null;
export default {
  components: { mytree },
  props: {},
  data() {
    return {
      tableHeight: 0,
      split: 0.2,
      searchCondition: {
        groupId: 0,
        typeId: "",
        pageSize: 10,
        jumpPage: 1,
        total: 0,
        questionLevelId: 0,
        name: "",
      },
      questionType: [],
      questionTypeForModal: [],
      questionTypeList: [],
      columns1: [
        {
          type: "selection",
          width: 60,
          align: "center",
          key: "choose",
        },
        {
          type: "index",
          width: 60,
          align: "center",
          title: "序号",
          indexMethod(row) {
            return (
              (that.searchCondition.jumpPage - 1) *
                that.searchCondition.pageSize +
              row._index +
              1
            );
          },
        },
        {
          title: "试题标题",
          key: "content",
          minWidth: 200,
          resizable: true,
        },
        {
          title: "试题标签",
          width: 80,
          key: "labelName",
        },
        {
          title: "作者",
          key: "accountName",
        },
        {
          title: "试题分类",
          width: 80,
          key: "groupName",
        },
        {
          title: "题型",
          key: "questionType",
        },
        {
          title: "分数",
          key: "score",
        },

        {
          title: "操作",
          slot: "action",
          // width: 150,
          align: "center",
        },
      ],
      data1: [],
      questionChoosen: [],
      treeModal: false,
      treeModalData: {
        value: "",
      },
    };
  },
  watch: {},
  computed: {},
  methods: {
    goTo(url) {
      this.$router.push({ name: url });
    },
    treeEvent(eventDetail, data) {
      switch (eventDetail.type) {
        case "rename":
          renameQuestionType({
            id: eventDetail.contextData.id,
            parentId: eventDetail.contextData.parentId,
            newName: eventDetail.value,
          }).then(
            (data) => {
              this.$Message.success("修改成功");
              this.questionTypeInit();
            },
            (data) => {
              this.$Message.error(data || "错误");
            }
          );

          break;
        case "delete":
          deleteQuestionType({
            id: eventDetail.value,
          }).then(
            (data) => {
              this.$Message.success("删除成功");
              this.questionTypeInit();
            },
            (data) => {
              this.$Message.error(data || "错误");
            }
          );
          break;
        case "append":
          appendQuestionType({
            parentId: eventDetail.parentId,
            groupName: eventDetail.title,
          }).then(
            (data) => {
              this.$Message.success("创建成功");
              this.questionTypeInit();
            },
            (data) => {
              this.$Message.success(data || "创建失败");
            }
          );
          break;
        case "move":
          moveQuestionType({
            id: eventDetail.id,
            newParentId: eventDetail.parentId,
            groupName: eventDetail.title,
          }).then(
            (data) => {
              this.$Message.success("移动成功");
              this.questionTypeInit();
            },
            (data) => {
              this.$Message.success(data || "移动失败");
            }
          );
          break;
        case "select":
          this.treeModalData.value = eventDetail.value;
          console.log(eventDetail.value.id);
          this.searchCondition.groupId = eventDetail.value.id;
          this.searchConditionInit();
          this.getQuestionList();
          // console.log(eventDetail);
          break;
        default:
          break;
      }
    },
    moveQuestionGroupEvent(eventDetail, data) {
      switch (eventDetail.type) {
        case "rename":
          renameQuestionType({
            id: eventDetail.contextData.id,
            parentId: eventDetail.contextData.parentId,
            newName: eventDetail.value,
          }).then(
            (data) => {
              this.$Message.success("修改成功");
              this.questionTypeInit();
            },
            (data) => {
              this.$Message.error(data || "错误");
            }
          );

          break;
        case "delete":
          deleteQuestionType({
            id: eventDetail.value,
          }).then(
            (data) => {
              this.$Message.success("删除成功");
              this.questionTypeInit();
            },
            (data) => {
              this.$Message.error(data || "错误");
            }
          );
          break;
        case "append":
          appendQuestionType({
            parentId: eventDetail.parentId,
            groupName: eventDetail.title,
          }).then(
            (data) => {
              this.$Message.success("创建成功");
              this.questionTypeInit();
            },
            (data) => {
              this.$Message.success(data || "创建失败");
            }
          );
          break;
        case "move":
          moveQuestionType({
            id: eventDetail.id,
            newParentId: eventDetail.parentId,
            groupName: eventDetail.title,
          }).then(
            (data) => {
              this.$Message.success("移动成功");
              this.questionTypeInit();
            },
            (data) => {
              this.$Message.success(data || "移动失败");
            }
          );
          break;
        case "select":
          this.treeModalData.value = eventDetail.value;
          // console.log(eventDetail);
          break;
        default:
          break;
      }
    },
    searchConditionInit() {
      Object.assign(this.searchCondition, { jumpPage: 1 });
    },
    treeModalconfirm() {
      let moveList = this.questionChoosen.reduce((total, item) => {
        total.push(item.id);
        return total;
      }, []);
      moveQuestionGroup({
        newGroupId: this.treeModalData.value.id,
        idList: moveList,
      }).then(
        (data) => {
          this.$Message.success("修改成功");
          this.getQuestionList();
        },
        (data) => {
          this.$Message.error("修改失败");
        }
      );
    },
    goToDetail(url, item) {
      this.$router.push({ path: url, query: { id: item.id } });
    },
    questionTypeUpdate() {},
    getQuestionList() {
      questionSearch(this.searchCondition).then((data) => {
        console.log(data);
        data.respList.forEach((item) => {
          item.content = item.content
            .replace(/<[^<>]+>/g, "")
            .replace(/&nbsp;/g, "")
            .replace(/&emsp;/g, "")
            .replace(/&ensp;/g, "");
        });
        this.data1 = data.respList;
        this.searchCondition.total = data.total;
      });
    },
    choosenChange(selection) {
      this.questionChoosen = selection;
    },
    showConfirmModal(type) {
      switch (type) {
        case "delete":
          this.$Modal.confirm({
            title: "删除试题",
            content:
              "<p>您确定要删除试题吗？删除后会影响添加了该题的试卷，请您谨慎操作</p>",
            onOk: () => {
              let deleteList = this.questionChoosen.reduce((total, item) => {
                total.push(item.id);
                return total;
              }, []);
              deleteQuestionList({ ids: deleteList.join(",") }).then(
                (data) => {
                  this.$Message.success("删除成功");
                  this.getQuestionList();
                },
                (data) => {
                  this.$Message.error("删除失败");
                }
              );
            },
            onCancel: () => {
              this.$Message.info("Clicked cancel");
            },
          });
          break;
        case "moveType":
          break;
        case "exported":
          break;
        default:
          break;
      }
    },
    showTreeChoose() {
      this.treeModal = true;
    },
    questionTypeInit() {
      getQuestionType().then((data) => {
        this.questionTypeForModal = JSON.parse(
          JSON.stringify(data.groupNodeList)
        );

        this.questionType = data.groupNodeList;
        this.questionType.unshift({
          id: 0,
          title: "所有分类",
          parentId: 0,
          children: [],
        });
      });
    },
    pageInit() {
      this.questionTypeInit();
      this.getQuestionList();
    },
    sliderClick(event) {
      let widthReduce = document.body.scrollWidth * 0.135;
      let widthMin = widthReduce + 150;
      document.onmousemove = (event) => {
        if (event.screenX > widthMin) {
          this.$refs.treeBox.style.width = event.screenX - widthReduce + "px";
        }
      };
      document.onmouseup = function () {
        document.onmousemove = null;
        document.onmouseup = null;
      };
    },
  },
  created() {},
  mounted() {
    that = this;
    this.tableHeight = document.body.clientHeight - 230;
    window.onresize = () => {
      this.$set(this.$data, "tableHeight", document.body.clientHeight - 230);
    };
    this.pageInit();
    getQuestionTypeList().then((data) => {
      data.unshift({ id: "", typeName: "所有题型" });
      this.questionTypeList = data;
    });
  },
};
</script>
<style lang="less" scoped>
.wrapper {
  .searchBar {
    padding: 10px 0;
    display: flex;
    justify-content: space-between;
    align-items: center;
    .searchInput {
      max-width: 300px;
    }
  }
  .twoSideBox {
    display: flex;
    position: relative;
    // max-height: 80vh;
    .leftBox {
      padding-top: 5px;
      // width: 200px;
      background: #fff;
    }
    .slider {
      width: 8px;
      background: rgba(0, 0, 0, 0.1);
      cursor: w-resize;
    }
    .rightBox::-webkit-scrollbar {
      display: none;
    }
    .rightBox {
      flex: 1;
      padding: 8px;
      min-height: 30vh;
      //   max-height: 80vh;
      background: #fff;
      overflow: scroll;
      .searchBar {
        display: flex;
        justify-content: space-between;
        padding: 10px 0;
      }
    }
  }
  .tableContainer {
  }

  .actBar {
    display: flex;
    // justify-content: space-between;
    padding-bottom: 5px;
    border-bottom: 3px solid #f5f6fa;
    flex: 1;
    button {
      margin: 3px 5px 2px 0;
    }
  }
}

/deep/ .ivu-table-cell {
  overflow: hidden; /*超出隐藏*/
  text-overflow: ellipsis; /*文本溢出时显示省略标记*/
  display: -webkit-box; /*设置弹性盒模型*/
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical; /*子代元素垂直显示*/
  padding-left: 5px;
  padding-right: 5px;
}
/deep/ .treeBar {
  font-size: 14px !important;
}
</style>